module.exports = __webpack_public_path__ + "img/project-3.b5d0fd11.png";